'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import { type FC } from 'react'

import {
  AD_BANNER_CATEGORY_SMALL_1,
  AD_BANNER_CATEGORY_SMALL_2,
  AD_BANNER_CATEGORY_SMALL_DIMENSIONS,
  AdServerBanner,
} from '../../../ad-server'
import { useDeviceDetectorContext } from '../../../device-detector'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokCategoryAdBannersSmallType } from '../../storyblok'

export const StoryblokCategoryAdBannersSmall: FC<
  StoryblokComponentProps<StoryblokCategoryAdBannersSmallType>
> = ({ blok }) => {
  const { isMobile } = useDeviceDetectorContext()

  const dimensions = isMobile
    ? AD_BANNER_CATEGORY_SMALL_DIMENSIONS.SMALL
    : AD_BANNER_CATEGORY_SMALL_DIMENSIONS.LARGE

  return (
    <div
      {...storyblokEditable(blok)}
      className="flex flex-col items-center justify-center gap-6 tablet:flex-row"
    >
      <AdServerBanner
        bannerTags={[AD_BANNER_CATEGORY_SMALL_1]}
        dimensions={dimensions}
        showSkeleton
      />
      <AdServerBanner
        bannerTags={[AD_BANNER_CATEGORY_SMALL_2]}
        dimensions={dimensions}
        showSkeleton
      />
    </div>
  )
}
